import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'
import ReEnrollActions, { ReEnrollRedux, ReEnrollTypes } from '../Redux/ReEnrollRedux'
import { notificationSuccess } from '../Redux/NotificationActions'
import ReEnrollmentsActions from '../Redux/ReEnrollmentsRedux'
import ClassroomActions from '../Redux/ClassroomRedux'

const reEnrollCrudObservable = createCRUDObservable({
  mainRedux: ReEnrollRedux,
  reduxPath: 'reEnroll',
})

const postReEnrollEpic = (action$, store, { Api }) =>
  action$.ofType(ReEnrollTypes.reEnrollRequest)
    .mergeMap(({ studentId, data }) => (
      Observable
        .fromPromise(Api.reEnroll.postReEnroll(studentId, data)
          .then(result => result)
          .catch(error => error))
        .flatMap((result) => {
          const { status } = result
          if (!(status >= 200 && status < 300)) {
            return [ReEnrollActions.reEnrollFailure(result.error)]
          }
          const { data: { data: payload } } = result
          return [
            ReEnrollActions.reEnrollSuccess(payload),
            notificationSuccess('Alumno Registrado'),
            ReEnrollmentsActions.updateDataAfterInscription(payload),
            ClassroomActions.updateDataAfterInscription(payload),
          ]
        })
    ))


export const reEnrollObservers = Object.assign({}, reEnrollCrudObservable.observers, {
  postReEnrollEpic,
})

export const reEnrollEpic = combineEpics(
  postReEnrollEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/ReEnrollObservable.js